// extracted by mini-css-extract-plugin
export default {"register-form":"RegisterForm_register-form__pbEff","register-description":"RegisterForm_register-description__zebjL","register-link":"RegisterForm_register-link__E-AAt"};